module.exports = __webpack_public_path__ + "img/badge-most-created-leads-silver.c2bc6b93.png";